import { Alert } from '@chronosphereio/chrono-ui';
import { useProductName } from '@chronosphereio/core';
import React from 'react';
import { AlertButton } from '@/chrono-ui-todos';
import { LogoPane } from '../components';
/**
 * View that the user is redirected to after successfully completing the Slack OAuth flow.
 */
export function SlackOAuthSuccess() {
  const productName = useProductName();
  const slackLink = 'https://app.slack.com/client';
  const goToSlack = () => {
    window.location.href = slackLink;
    return null;
  };

  return (
    <LogoPane>
      <Alert severity="success" Action={<AlertButton onClick={goToSlack}>Open Slack</AlertButton>}>
        You have successfully connected {productName} to Slack. <p>You can safely close this window.</p>
      </Alert>
    </LogoPane>
  );
}
